<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record
        title="Subcategoría de pago"
        resource="pago_subcategorias"
        primaryKey="idpago_subcategoria"
        :record="record"
        :columns="columns"
        @saveChanges="handleSave"
        :service="service"
        :backLink="
          (record) => {
            return '/pago_categorias/' + record.idpago_categoria;
          }
        "
      />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import Pago_subcategoriaService from "@/services/pago_subcategoria.service";
import { pago_subcategoria } from "@/models/pago_subcategoria";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: pago_subcategoria,
      service: Pago_subcategoriaService,
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        Pago_subcategoriaService.get(this.$route.params.id)
          .then((data) => {
            this.record = data.record;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    },
  },
};
</script>
